
<template>
  <!-- <div class="modal" :class="{show: visible}"> -->
  <div class="modal" id="modal"  @click.self="hide()">
    <div class="modal_content" :style="{width:getWidth, height:getHeight}">
      <div class="modal_header">
        <!-- <h1 class="modal_title">あそびかた</h1> -->
        <h1 class="modal_title"></h1>
        <span class="modal_close" @click="hide()"> ×</span>
      </div>
      <div class="modal_body">
        <!-- <span class="modal_close" @click="hide()"> ×</span> -->
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:"Modal",
  props:{
    width: {type:[String, Number], default :600},
    height: {type:[String, Number], default :"auto"},
  },
  methods:{
    show(){
      const modal = document.getElementById("modal");
      modal.classList.add("show");
    },
    hide(){
      const modal_1 = document.getElementById("modal_explain");
      const modal_2 = document.getElementById("modal_done");
      modal_1.classList.remove("show");
      modal_2.classList.remove("show");
    }
  },
  computed:{
    getWidth(){
      if(typeof this.width=="number"){
        return `${this.width}px`;
      }
      return this.width;
    },
    getHeight(){
      if(typeof this.height=="number"){
        return `${this.height}px`;
      }
      return this.height;
    },
  }
};
</script>

<style scoped>
*{
  margin:0;
  padding:0;
  box-sizing:border-box;
}
.modal{
  position: fixed;
  display:flex;
  align-items:center;
  top: 0;
  left: 0;
  right: 0;
  bottom:0;
  background:rgba(37, 36, 36, 0.767);
  visibility:hidden;
  opacity:0;
  transition: opacity 0.45 ease-in-out, visibility 0.4s ease-in-out;
}
.modal.show{
  visibility: visible;
  opacity:1;
}
.modal.show .modal_content{
  visibility: visible;
  opacity:1;
  transform: scale(1);
}

.modal_content {
  min-width:370px;
  width:450px;
  /* background-color:rgba(42, 79, 245, 0.342); */
  background-color:white; 
  margin: 0 auto;
  visibility: hidden;
  opacity:0;
  transform: scale(0.5);
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out, transform 0.4s ease-in-out;
  border-radius: 5px;
}
.modal_header{
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding: 5px 10px;
  /* border-bottom: 1px solid #eee; */
  background-color:rgba(42, 79, 245, 0.342);
}
.modal_title{
  font-weight: normal;
  font-size:25px;
}
.modal_close{
  padding:5px;
  cursor:pointer;
  font-size:25px;
}
.modal_body{
  text-align:center;
  text-align:justify;
  background-color:rgba(42, 79, 245, 0.342);
  padding-bottom:2%;
}

</style>